import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class EnvironmentInterceptor implements HttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (req.url.startsWith('assets')) {
      return next.handle(req);
    }

    let baseUrl = environment.apiUrl;

    // Check custom header
    // if (req.headers.get('X-API-TYPE') === 'OTHER') {
    //   baseUrl = environment.otherUrl;
    // }

    const apiReq = req.clone({
      url: `${baseUrl}${req.url}`,
      headers: req.headers.delete('X-API-TYPE')
    });

    return next.handle(apiReq);
  }
}
